/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FileListDto = {
    kycPdfOid?: string;
    kycFormOid?: string;
    type: string; //FileListDto.type; // updated to handle multiple types
    fileType?: string;
    page?: number;
    limit?: number;
}

export namespace FileListDto {

    export enum type {
        MISC = 'MISC',
        ACRA = 'ACRA',
        SPF = 'SPF',
        CREDIT_BUREAU = 'CREDIT_BUREAU',
        DASHBOARD = 'DASHBOARD',
        EFNA = 'EFNA',
    }


}
